/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgCallIncoming = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="m9.28 2.935.9 6.303-3.72 3.72a18.511 18.511 0 0 0 1.952 2.29l.442.428c.476.447.968.864 1.47 1.245l.378.28 3.72-3.72 6.304.9v5.524l-.293.293c-2.193 2.193-6.265 1.685-10.225-.91a20.123 20.123 0 0 1-2.829-2.253l-.381-.372a20.315 20.315 0 0 1-2.626-3.21C1.777 9.492 1.27 5.42 3.462 3.227l.293-.293zm5.85 12.667-2.691 2.69c2.521 1.362 4.826 1.638 6.144.833l.143-.094v-2.915zM7.544 4.935H4.629c-.918 1.29-.674 3.671.738 6.287L8.058 8.53zm12.748-3.642 1.414 1.414L17.414 7H21v2h-7V2h2v3.586z"
      fill="currentcolor"
      fillRule="evenodd"
    />
  </Icon>
);
export { SvgCallIncoming as CallIncoming };
